import { Button, Grid, TextField, Typography } from "@mui/material";
import React, { ChangeEvent, SyntheticEvent } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import GroupedCountries from "../Handlers/CountryHandler";

interface ProfileFormProps {
  formData: {
    name: string;
    surname: string;
    email: string;
    phonenumber: string;
    city: string;
    country: string;
  };
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleCountryChange: (event: SyntheticEvent, newValue: string | null) => void;
  handleSubmit: (e: React.FormEvent) => Promise<void>;
}

const ProfileForm: React.FC<ProfileFormProps> = ({
  formData,
  handleChange,
  handleCountryChange,
  handleSubmit,
}) => {
  const intl = useIntl();

  return (
    <form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h4" mt={2}>
            <FormattedMessage id="update-profile" />
          </Typography>
        </Grid>
        <Grid item xs={12} lg={2}>
          <Typography variant="h6" mt={2}>
            <FormattedMessage id="name" />:
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <TextField
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder={intl.formatMessage({
              id: "name",
              defaultMessage: "Name",
            })}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <TextField
            type="text"
            name="surname"
            value={formData.surname}
            onChange={handleChange}
            placeholder={intl.formatMessage({
              id: "surname",
              defaultMessage: "Last/Surname",
            })}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} lg={2}>
          <Typography variant="h6" mt={2}>
            <FormattedMessage id="contact-info" />:
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <TextField
            type="number"
            name="phonenumber"
            value={formData.phonenumber}
            onChange={handleChange}
            placeholder={intl.formatMessage({
              id: "phoneNumber",
              defaultMessage: "Phone Number",
            })}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <TextField
            type="text"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder={intl.formatMessage({
              id: "email",
              defaultMessage: "Change Email",
            })}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} lg={2}>
          <Typography variant="h6" mt={2}>
            <FormattedMessage id="location" />:
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <TextField
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder={intl.formatMessage({
              id: "city",
              defaultMessage: "Home City",
            })}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={6} lg={5}>
          <GroupedCountries
            country={formData.country}
            handleCountryChange={handleCountryChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" type="submit" fullWidth>
            <FormattedMessage id="save-details" />
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default ProfileForm;
